import { Component, forwardRef, inject, input, Input } from '@angular/core';
import { TeamItemDto, TeamService } from '@artemis-software/wr-api';
import { currentTenantId } from '@/utils/admin-utils';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractFormControl } from '@shared/form-controls/abstract-form-control';
import { Router } from '@angular/router';
import { Tracked } from '@/utils/signals/tracked';
import {
  AssignmentType,
  PickListBehaviour,
  UnpaginatedPickListBehaviour,
} from '@shared/form-controls/generic-pick-list/generic-pick-list.component';
import { firstValueFrom } from 'rxjs';

@Component({
  standalone: false,
  selector: 'wr-team-pick-list',
  templateUrl: './team-pick-list.component.html',
  styleUrls: ['./team-pick-list.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TeamPickListComponent),
      multi: true,
    },
  ],
})
export class TeamPickListComponent extends AbstractFormControl<TeamItemDto[]> implements UnpaginatedPickListBehaviour<TeamItemDto> {

  @Input()
  @Tracked()
  regionId: string | null = null;

  readonly teamService = inject(TeamService);
  readonly router = inject(Router);

  readonly getAssignmentTypeFunction = input.required<(team: TeamItemDto) => AssignmentType>();

  readonly currentTenantId = currentTenantId();

  isPaginated = false as const;

  async getAllItems(): Promise<TeamItemDto[]> {
    const tenantId = this.currentTenantId();
    if (!tenantId) {
      return [];
    }
    return firstValueFrom(this.teamService.findAll({ tenantId: this.currentTenantId() }));
  }

  getAssignmentType(item: TeamItemDto): AssignmentType {
    return this.getAssignmentTypeFunction()(item);
  }

  getDisplayName(item: TeamItemDto): string {
    return item.name;
  }

  getSecondAdditionalInfo(item: TeamItemDto): string {
    const formatted = new Intl.NumberFormat('de-AT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(item.totalArea);

    return `${formatted} m²`;
  }

  getThirdAdditionalInfo(item: TeamItemDto): string {
    return item.userCount.toString();
  }

  showToggleAssignedFromOthers(): boolean {
    return true;
  }

}
